import { UserAuthentication, UserToken } from "@core/models/domain/auth.domain";

export interface AuthState {
  authentication: UserAuthentication | null;
  loading: boolean;
  error: string | null;
  isHydrated: boolean;
}

export const initialAuthState: AuthState = {
  authentication: null,
  loading: false,
  error: null,
  isHydrated: false
};

export interface TokenState {
  token: UserToken | null;
  loading: boolean;
  error: string | null;
}

export const initialTokenState: TokenState = {
  token: null,
  loading: false,
  error: null
};
